export const sectionStyles = {
  wrapper: "py-20 bg-white dark:bg-dark-bg even:bg-gray-50 even:dark:bg-dark-bg",
  container: "container mx-auto px-4",
  content: "max-w-4xl mx-auto",
  title: "text-3xl font-bold text-center mb-12 text-gray-900 dark:text-white",
  card: "bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 h-full",
  grid: "grid gap-8 grid-cols-1 md:grid-cols-2",
  flexCenter: "flex items-center justify-center",
  tag: "px-3 py-1 text-sm bg-indigo-100 dark:bg-indigo-900 text-indigo-600 dark:text-indigo-300 rounded-full",
  link: "text-gray-600 dark:text-gray-300 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors duration-200"
}; 